import tokens from "@alterra-mountain-company/alterra-design-system/tokens/ikonWeb";

import I18n from "~/i18n";
import base from "../base";
import { BrandInterface } from "../interface";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-32x32.png";
import favicon96 from "./favicon-96x96.png";
import logo from "./logo.svg";

const ikonapp = {
  ...base,
  title: "Ikon Pass App",
  logo,
  fontFamily: "futura-pt, sans-serif;",
  resortURL: () => `https://ikonpass.com/${I18n.locale}`, // We need to support locales
  socialAccount: "add_social_account",
  v2Extension: "_v2",
  enabled: {
    ...base.enabled,
    logoLockup: false,
    submitButtonAboveForgotPassword: true,
    errorTextBelowInput: false,
    extendedPasswordTooShortMessage: true,
    visablePasswordIndicator: true,
    showAllErrorsTogether: true,
  },
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    ...base.color,
    textColor: tokens.color.text.default,
    textColorAlt: tokens.color.text.onDark,
    header: tokens.color.background.headerNav.bar,
    footer: "transparent",
    footerText: tokens.color.text.footerNav.bar,
    button: tokens.color.background.button.default,
    buttonHover: tokens.color.background.button.hover,
    buttonDisabled: tokens.color.background.disabled,
    input: tokens.color.text.subdued,
    inputBorder: tokens.color.border.input.default,
    inputFocus: tokens.color.border.input.focused,
    inputError: tokens.color.border.danger,
    inputErrorText: tokens.color.text.danger,
    inputLabel: tokens.color.text.default,
    inputLabelError: tokens.color.text.danger,
    inputBackground: tokens.color.background.input.default,
    error: tokens.color.border.danger,
    errorBackground: tokens.color.background.danger.subdued,
    backgroundSubdued: tokens.color.background.subdued.default,
  },
} as BrandInterface;

export default ikonapp;
